import { RentGuaranteeExperimentVariation } from '@zg-rentals/rental-manager-env';
import pathsManifest from '../pathsManifest';
import { ENTRY_POINT_PATH } from '../containers/RentGuaranteePage/constants';
import type { RentalProtectionExperimentDetail } from '../model/RentGuarantee';
import type { ResourcesModuleProps } from '../model/RentGuarantee/ResourcesModule';
import type { CurrentPropertyProps } from '../model/CurrentProperty';
import { updateLocation } from '../slices/app';

const paths = pathsManifest.getAllPaths('zillow');

export const getRentalProtectionPageUrl = (listingAlias: string) => {
  const { rentGuaranteePage, properties } = paths;

  return `${rentGuaranteePage}/${properties}/${listingAlias}`;
};

// Gets object values as type
// https://stackoverflow.com/a/53662389
type EntryPointPathKeys = keyof typeof ENTRY_POINT_PATH;
type EntryPointPathValueType = (typeof ENTRY_POINT_PATH)[EntryPointPathKeys];

export const isFromRentalProtectionPostListingActivationUpsell = (entryPoint: EntryPointPathValueType) =>
  entryPoint === ENTRY_POINT_PATH.POST_LISTING_ACTIVATION_SOFT_UPSELL ||
  entryPoint === ENTRY_POINT_PATH.POST_LISTING_ACTIVATION_HARD_UPSELL;

// @ts-expect-error
export const getRentalProtectionLightweightOptinExperiment = (experiments) =>
  experiments['rental-protection-lightweight-optin'];

export const getExperimentNameArrFromExperimentDetails = (
  experimentDetails: Array<RentalProtectionExperimentDetail>,
) => {
  return experimentDetails ? experimentDetails.map((experiment) => experiment.variation) : null;
};

export const redirectToManagePoliciesPage = (moduleId: string, listingAlias: string) => {
  // @ts-expect-error
  window.store.dispatch(
    updateLocation(`${paths.rentGuaranteePage}/properties/${listingAlias}/managePolicies/${moduleId}`),
  );
};

export const getCustomerSupportEmailFromResourcesModule = (resourcesModule: ResourcesModuleProps) => {
  return `mailto:${resourcesModule?.emailUs[0]?.url}`;
};

export const getIsLowFrictionEnabledFromProperty = (propertyDetails: CurrentPropertyProps) => {
  return (
    Array.isArray(propertyDetails?.rentalProtection?.experimentsDetails) &&
    propertyDetails.rentalProtection.experimentsDetails.some(
      (experiment) => experiment.variation === RentGuaranteeExperimentVariation.LOW_FRICTION,
    )
  );
};
